var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApplyMortgage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "96.000000pt",
    height: "96.000000pt",
    viewBox: "0 0 96.000000 96.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,96.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M260 754 c-263 -227 -247 -211 -233 -225 9 -9 19 -6 41 10 29 21 39 21 412 21 373 0 383 0 412 -21 22 -16 32 -19 41 -10 8 8 7 15 -3 25 -38 37 -444 386 -450 386 -3 0 -102 -84 -220 -186z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654 868 c-5 -7 15 -32 52 -65 l59 -53 3 51 c2 29 1 58 -2 65 -7 18 -102 19 -112 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 290 l0 -230 360 0 360 0 0 230 0 230 -360 0 -360 0 0 -230z m280 5 l0 -105 -75 0 -75 0 0 105 0 105 75 0 75 0 0 -105z m310 0 l0 -105 -75 0 -75 0 0 105 0 105 75 0 75 0 0 -105z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplyMortgage);
export default __webpack_public_path__ + "static/media/apply-mortgage.343d5bdfdf48fd24e9598fb0313298ca.svg";
export { ForwardRef as ReactComponent };